import { isStreamingUxExperienceM1Enabled } from './streaming-ux-experience-m1-enabled';

/**
 * The streaming grey-out dims the source content while the AI response is applied.
 * The M1 streaming UX experiment suppresses it for the treatment cohort.
 */
export const isStreamingGreyoutSuppressed = (): boolean => isStreamingUxExperienceM1Enabled();
